// extracted by css-extract-rspack-plugin
export default {"cls1":"BlurredHiddenThumbs-cls1_DjY","cls2":"BlurredHiddenThumbs-cls2_76G BlurredHiddenThumbs-cls1_DjY"};